<div class="searchbox-container">
    <div class="searchbox--">
        <input
            outlined
            [(ngModel)]="dialogSearchTerm"
            typeof="search"
            placeholder="Search"
            [ngStyle]="{ height: searchBoxHeight.toString() + 'px' }"
            class="searchbox-input"
        />
        <mat-icon
            class="search-box-icon"
            matTextFieldIcon
            trailing
            [clickable]="dialogSearchTerm !== ''"
            fontSet="fas"
            fontIcon="{{ isSearchEmpty ? 'fa-search' : 'fa-times' }}"
            (click)="clearButtonClick(suffix)"
        >
        </mat-icon>
    </div>
</div>
